// components/NotificationQueue.js
import React from 'react'
import { useNotificationStore } from 'store/NotificationStore'
import { Alert, Button, Stack } from '@mui/material'

export default function NotificationQueue() {
  const { notifications, removeNotification } = useNotificationStore()

  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 1300, // above most content
      }}
    >
      {notifications.map((n) => (
        <Alert
          key={n.id}
          severity={n.type || 'info'}
          onClose={
            n.duration === undefined
              ? () => removeNotification(n.id)
              : undefined
          }
          action={
            n.action ? (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  n.action.onClick()
                  removeNotification(n.id)
                }}
              >
                {n.action.label}
              </Button>
            ) : null
          }
          // if you later want auto-hide, you can wrap these Alerts in a Snackbar
        >
          {n.message}
        </Alert>
      ))}
    </Stack>
  )
}